import React, { useState } from 'react';

const E  = '#7C4DFF';
const ED = '#6030E8';
const N  = '#0A2540';

const experiences = [
  {
    role: 'Assistant Manager – Digital Financial Services',
    company: 'MicroSave Consulting',
    location: 'Nairobi, Kenya',
    period: 'May 2024 – Present',
    type: 'Current',
    color: E,
    bullets: [
      'Lead business development efforts through engagement with existing and potential partners.',
      'Coordinate multi-country project assignments across Sub-Saharan Africa — overseeing consultants, timelines, and deliverables.',
      'Lead stakeholder engagement with donors, partners, and government institutions.',
      'Provide technical assistance including project design, budgeting, and implementation support.',
      'Develop and publish knowledge resources: blogs, case studies, research reports.',
    ],
  },
  {
    role: 'Operation Analyst – Card & ATM Operations',
    company: 'NCBA Bank',
    location: 'Nairobi, Kenya',
    period: 'Oct 2022 – May 2024',
    type: 'Past',
    color: '#2D7BE4',
    bullets: [
      'Championed initiatives that improved customer experience and reduced support queries by 50%.',
      'Coordinated training for subsidiaries and customer-facing teams.',
      'Collaborated on digital transformation projects including system integration.',
      "Facilitated integration of ATM machines acquired through mergers into the bank's infrastructure.",
      'Supported automation projects and process optimization initiatives.',
    ],
  },
  {
    role: 'Graduate Trainee – Retail Digital Banking',
    company: 'NCBA Bank',
    location: 'Nairobi, Kenya',
    period: 'Mar 2022 – Oct 2022',
    type: 'Past',
    color: '#7C4DFF',
    bullets: [
      "Initiated quarterly contact centre training that reduced department-directed queries by 50%.",
      "Championed reduction of mobile loan defaulters' cooling period from 90 to 30 days.",
      'Grew the digital Distributor Finance loan book.',
      'Conducted test analysis on digital banking products in development and upgrade phases.',
    ],
  },
  {
    role: 'Economic Strengthening Lead / Facilitator',
    company: 'Hope Worldwide Kenya (Ciheb Kenya)',
    location: 'Kenya',
    period: 'Sep 2020 – Mar 2022',
    type: 'Past',
    color: '#FF6B35',
    bullets: [
      'Coordinated vocational training and business startup programs for 700+ adolescent girls and young women (AGYW).',
      'Trained 1,000+ AGYWs on financial capability, healthy choices, and life skills.',
      'Delivered financial literacy and business development training supporting 120+ small businesses.',
      'Facilitated partnerships with training institutions and suppliers.',
      'Monitored and reported project activities including timesheets and intervention tracking.',
    ],
  },
];

export default function Experience() {
  const [active, setActive] = useState(0);
  const exp = experiences[active];

  return (
    <section id="experience" className="section" style={{ background: N }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          {/* Section label — white/subtle on dark */}
          <div style={{
            display: 'inline-block',
            background: 'rgba(255,255,255,0.10)',
            color: 'rgba(255,255,255,0.80)',
            border: '1px solid rgba(255,255,255,0.18)',
            padding: '4px 14px', borderRadius: 20,
            fontSize: '0.78rem', fontWeight: 700, marginBottom: 12, letterSpacing: '1px',
          }}>
            WORK HISTORY
          </div>
          <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '2.2rem', color: '#fff', fontWeight: 800 }}>
            Professional Experience
          </h2>
          <div style={{ width: 60, height: 4, background: E, borderRadius: 2, margin: '14px auto 0' }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: 32 }}>
          {/* Tab list */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {experiences.map((e, i) => (
              <button key={i} onClick={() => setActive(i)} style={{
                textAlign: 'left', padding: '14px 18px', borderRadius: 10, cursor: 'pointer',
                background: active === i ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.03)',
                border: active === i ? '1px solid rgba(255,255,255,0.20)' : '1px solid rgba(255,255,255,0.06)',
                transition: 'all 0.2s', fontFamily: 'inherit',
                borderLeft: active === i ? `3px solid ${e.color}` : '3px solid transparent',
              }}>
                <div style={{ color: active === i ? '#fff' : 'rgba(255,255,255,0.50)', fontWeight: 600, fontSize: '0.85rem' }}>
                  {e.company}
                </div>
                <div style={{ color: 'rgba(255,255,255,0.28)', fontSize: '0.75rem', marginTop: 3 }}>{e.period}</div>
              </button>
            ))}
          </div>

          {/* Content */}
          <div style={{
            background: 'rgba(255,255,255,0.05)', borderRadius: 14,
            border: '1px solid rgba(255,255,255,0.10)', padding: 32,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12, marginBottom: 24 }}>
              <div>
                <h3 style={{ color: '#fff', fontSize: '1.3rem', fontWeight: 700, marginBottom: 6 }}>{exp.role}</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                  <span style={{ color: exp.color, fontWeight: 600, fontSize: '0.95rem' }}>{exp.company}</span>
                  <span style={{ color: 'rgba(255,255,255,0.25)' }}>•</span>
                  <span style={{ color: 'rgba(255,255,255,0.40)', fontSize: '0.85rem' }}>{exp.location}</span>
                </div>
              </div>
              <span style={{
                background: exp.type === 'Current' ? 'rgba(124,77,255,0.15)' : 'rgba(255,255,255,0.06)',
                color:      exp.type === 'Current' ? E : 'rgba(255,255,255,0.38)',
                border:     `1px solid ${exp.type === 'Current' ? 'rgba(124,77,255,0.35)' : 'rgba(255,255,255,0.10)'}`,
                padding: '4px 12px', borderRadius: 20, fontSize: '0.8rem', fontWeight: 600,
              }}>
                {exp.period}
              </span>
            </div>

            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
              {exp.bullets.map((b, i) => (
                <li key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: exp.color, marginTop: 8, flexShrink: 0 }} />
                  <span style={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.7, fontSize: '0.92rem' }}>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #experience .container > div:last-child { grid-template-columns: 1fr !important; }
          #experience .container > div:last-child > div:first-child { flex-direction: row !important; overflow-x: auto; }
        }
      `}</style>
    </section>
  );
}
